import script from "./OptionsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionsForm.vue?vue&type=script&setup=true&lang=js"

import "./OptionsForm.vue?vue&type=style&index=0&id=48ffe9f4&lang=css"

const __exports__ = script;

export default __exports__